import React, { useMemo, useCallback } from "react";
import { Formik, Form } from "formik";
import { FormikInput, ModalSubmit } from "components/common";
import { Modal } from "components/bootstrap";
import EntityCreateShareFormGroup from "components/permissions/EntityCreateShareFormGroup";
import { useTranslation } from "react-i18next";
import i18n from "i18n";
const prepareInitialCollection = (initialCollection) => {
  var _a, _b;
  return {
    title: (_a = initialCollection == null ? void 0 : initialCollection.title) != null ? _a : "",
    description: (_b = initialCollection == null ? void 0 : initialCollection.description) != null ? _b : ""
  };
};
const validate = (values) => {
  let errors = {};
  if (!values.title) {
    errors = { ...errors, title: i18n.t("collection_modal.title_required", { ns: "enterprise_collections" }) };
  }
  if (!values.description) {
    errors = {
      ...errors,
      description: i18n.t("collection_modal.description_required", { ns: "enterprise_collections" })
    };
  }
  return errors;
};
const CollectionModal = ({
  title: modalTitle,
  submitButtonText,
  submitLoadingText,
  onClose,
  onSubmit,
  create = false,
  initialCollection = null
}) => {
  const { t } = useTranslation("enterprise_collections");
  const initialValues = useMemo(() => prepareInitialCollection(initialCollection), [initialCollection]);
  const onSubmitChained = useCallback(
    (values) => onSubmit(values).then(() => onClose()),
    [onClose, onSubmit]
  );
  return /* @__PURE__ */ React.createElement(Modal, { onHide: onClose, show: true }, /* @__PURE__ */ React.createElement(Formik, { initialValues, onSubmit: onSubmitChained, validate }, ({ isSubmitting, isValidating, setFieldValue }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, modalTitle)), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(FormikInput, { label: t("shared.title"), name: "title", id: "title", help: t("collection_modal.title_help") }), /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      label: t("shared.description"),
      name: "description",
      id: "description",
      help: t("collection_modal.description_help")
    }
  ), create && /* @__PURE__ */ React.createElement(
    EntityCreateShareFormGroup,
    {
      description: t("shared.share_collection_description"),
      entityType: "collection",
      onSetEntityShare: (payload) => setFieldValue("share_request", payload)
    }
  )), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
    ModalSubmit,
    {
      submitButtonText,
      submitLoadingText,
      onCancel: onClose,
      disabledSubmit: isValidating,
      isSubmitting
    }
  )))));
};
export default CollectionModal;
